




























































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable key-spacing */
/* eslint-disable class-methods-use-this */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import format from '@/libs/numberFormat';
import { api2 } from '@/libs/api';
import Pagination from '@/components/Pagination.vue';
// import SimplePagination from '@/components/SimplePagination.vue';
import { AxiosError } from 'axios';
import Button from '@/components/Button.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Modal from '@/components/Modal.vue';
import CloseIcon from 'mdi-vue/Close';
import PencilIcon from 'mdi-vue/SquareEditOutline';
import dayjs from 'dayjs';
import StagingMatchModal from './StagingMatchModal.vue';

@Component({
  components: {
    ScrollbarWrapper,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Pagination,
    // SimplePagination,
    Button,
    Modal,
    CloseIcon,
    PencilIcon,
    StagingMatchModal,
  },
  methods: {
    format,
  },
  computed: mapState(['user']),
})

export default class StagingTable extends Vue {
  $refs!: {
    report: StagingMatchModal;
  }

  forms = [
    {
      is_cell_show: 0, form_type: '', column_db: '', form_date_format: '',
    },
  ];

  rows = [];
  actions = [];

  templateCode = '';
  loading = true;
  from = 0;
  to = 0;
  totalItem = 0;
  totalPage = 1;
  hasNext = true;
  hasPrev = false;
  page = 1;
  // searchKey = '';
  searchParams: any = {};
  isShowModal = false;

  @Watch('page')
  onPageChange() {
    this.getTransaction(this.templateCode, null, this.searchParams, this.page);
  }

  prev() {
    this.page -= 1;
    this.getTransaction(this.templateCode, null, this.searchParams, this.page);
  }

  next() {
    this.page += 1;
    this.getTransaction(this.templateCode, null, this.searchParams, this.page);
  }

  async getTransaction(templateCode: string, forms: any, searchParams: any, pageParams: any) {
    try {
      if (templateCode) {
        this.templateCode = templateCode;
      }
      if (forms) {
        this.forms = forms;
        this.forms = this.forms.filter((form) => form.is_cell_show === 1);
      }
      if (searchParams) {
        this.searchParams = searchParams;
        const tmpForms = this.forms.filter((form) => form.form_type === 'singledatepicker'
          && form.column_db !== 'data_date'
          && form.column_db !== 'period_date');
        tmpForms.forEach((form) => {
          if (this.searchParams[form.column_db] && this.searchParams[form.column_db].startDate) {
            const formDateFormat = form.form_date_format;
            const formDateValue = this.searchParams[form.column_db].startDate;
            this.searchParams[form.column_db] = dayjs(formDateValue).format(formDateFormat);
          }
        });
      }
      if (!pageParams) {
        this.page = 1;
      }

      this.loading = true;
      const { data } = await api2.post(`/recon/stg/data/${templateCode}`, {
        searchParams: this.searchParams,
        page: this.page,
      });

      this.rows = data.data ? data.data : [];
      this.actions = data.action ? data.action : [];
      if (data.data) {
        if (this.page === 1) {
          this.from = 0;
          this.to = data.data ? data.data.length : 0;
        } else {
          this.from = data.data ? data.maxPage * (this.page - 1) : 0;
          this.to = data.data ? data.data.length + (data.maxPage * (this.page - 1)) : 0;
        }
      }
      // this.to = data.data ? data.data.length + (data.maxPage * this.page) : 0;
      this.totalItem = data.count;
      // this.totalPage = Math.ceil(data.total / data.per_page);
      this.totalPage = Math.ceil(data.count / data.maxPage);
      this.hasNext = data.next;
      this.hasPrev = data.prev;
      this.loading = false;
      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  showManualMatchModal(id: number) {
    try {
      console.log(`error : ${id}`);
      // this.isShowModal = true;
      this.$refs.report.showModal();
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'error');
    }
  }

  closeModal() {
    this.isShowModal = false;
  }
}
